const initialState = {
    data: null,
}
export const DownloadFilesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DOWNLOAD_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'DOWNLOAD_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default DownloadFilesReducer;